import { ERROR_CODES } from 'constants/statusCodes';

/**
 * Backend validation errors use `message` as IErrorMessage[][].
 * Other responses (wrong host, proxies, generic APIs) may use a string or omit it.
 */
function isRecordWithErrorCode(value: unknown): value is { errorCode: string } {
  return typeof value === 'object' && value !== null && 'errorCode' in value;
}

export default function isDeactivatedAccountMessage(message: unknown): boolean {
  if (!Array.isArray(message)) {
    return false;
  }
  return message.some(
    (messageArray) => Array.isArray(messageArray)
      && messageArray.some(
        (item) => isRecordWithErrorCode(item) && item.errorCode === ERROR_CODES.deactivated,
      ),
  );
}
